var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPubmed = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ className: "pubmed_svg__icon", viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: 200, height: 200 }, props), /* @__PURE__ */ React.createElement("path", { d: "M128 64h448l192 448-192 448H128A128 128 0 0 1 0 832V192A128 128 0 0 1 128 64z", fill: "#205992" }), /* @__PURE__ */ React.createElement("path", { d: "M704 64h128l192 448-192 448H704l192-448z", fill: "#205992" }));
export { SvgPubmed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PHBhdGggZD0iTTEyOCA2NGg0NDhsMTkyIDQ0OC0xOTIgNDQ4SDEyOEExMjggMTI4IDAgMCAxIDAgODMyVjE5MkExMjggMTI4IDAgMCAxIDEyOCA2NHoiIGZpbGw9IiMyMDU5OTIiLz48cGF0aCBkPSJNNzA0IDY0aDEyOGwxOTIgNDQ4LTE5MiA0NDhINzA0bDE5Mi00NDh6IiBmaWxsPSIjMjA1OTkyIi8+PC9zdmc+";
